let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3C3qD")).then(() => parcelRequire('aTlUh'));